import React from 'react';
import { Switch } from 'react-router-dom';

// import Home from '~/pages/company/Home';
import Settings from '~/pages/company/Settings';
import Categories from '~/pages/company/Categories';
import CategoryForm from '~/pages/company/CategoryForm';
import Products from '~/pages/company/Products';
import ProductForm from '~/pages/company/ProductForm';
import Orders from '~/pages/company/Orders';
import OrderDetails from '~/pages/company/OrderDetails';
import Complements from '~/pages/company/Complements';
import ComplementForm from '~/pages/company/ComplementForm';
import ComplementItems from '~/pages/company/ComplementItems';
import ComplementItemForm from '~/pages/company/ComplementItemForm';
import CategoryComplements from '~/pages/company/CategoryComplements';
import BannersForm from '~/pages/company/BannersForm';
import Deliverymen from '~/pages/company/Deliverymen';
import DeliverymenForm from '~/pages/company/DeliverymenForm';
import Clients from '~/pages/company/Clients';
import ClientForm from '~/pages/company/ClientForm';
import ClientAddresses from '~/pages/company/ClientAddresses';
import ClientAddressForm from '~/pages/company/ClientAddressForm';
import DistancesForm from '~/pages/company/DistancesForm';
import Resume from '~/pages/company/Resume';
import TablesForm from '~/pages/company/TablesForm';
import OrdersTable from '~/pages/company/OrdersTable';
import OrderTableDetails from '~/pages/company/OrderTableDetails';
import Menus from '~/pages/company/Menus';
import Coupons from '~/pages/company/Coupons';

// IMPRIMIR QR CODES - aumentar escala para 102 da impressao caso necessario
import PrintQrCode from '~/layouts/Dashboard/PrintQrCode';
// import OrderForm from '~/pages/company/OrderForm';

import AppHome from '~/pages/app/Home';
import AppAbout from '~/pages/app/About';
import AppCart from '~/pages/app/Cart';
import AppCheckout from '~/pages/app/Checkout';
import AppOrders from '~/pages/app/Orders';
import AppHomeCategory from '~/pages/app/HomeCategory';
import ClientsBuyOnCredit from '~/pages/company/ClientsBuyOnCredit';
import OrdersOnCredit from '~/pages/company/OrdersOnCredit';
import MenuForm from '~/pages/company/MenuForm';
import Route from './Route';
import Supplies from '~/pages/company/Supplies';
import SupplieForm from '~/pages/company/SupplieForm';
import CouponForm from '~/pages/company/CouponForm';
import OrdersClient from '~/pages/company/OrdersClient';
import CashFlowForm from '~/pages/company/CashFlowForm';
import { Test } from '~/pages/Test';
import Promoter from '~/pages/company/Promoter';

const { REACT_APP_CHATBOT_WPP } = process.env;

const CompanyRoutes: React.FC = () => {
  return (
    <Switch>
      {/* DASHBOARD */}
      <Route path="/" exact component={Orders} isPrivate />

      <Route path="/test" exact component={Test} isPrivate />

      <Route path="/categories" exact component={Categories} isPrivate />
      <Route path="/categories/create" component={CategoryForm} isPrivate />
      <Route path="/categories/edit/:id" component={CategoryForm} isPrivate />
      <Route
        path="/categories/complements/:id"
        exact
        component={CategoryComplements}
        isPrivate
      />

      <Route path="/products" exact component={Products} isPrivate />
      <Route path="/products/create" component={ProductForm} isPrivate />
      <Route path="/products/edit/:id" component={ProductForm} isPrivate />

      <Route path="/complements" exact component={Complements} isPrivate />
      <Route path="/complements/create" component={ComplementForm} isPrivate />
      <Route
        path="/complements/edit/:id"
        component={ComplementForm}
        isPrivate
      />

      <Route
        path="/complements/items/:id"
        exact
        component={ComplementItems}
        isPrivate
      />
      <Route
        path="/complements/items/:id/create"
        exact
        component={ComplementItemForm}
        isPrivate
      />
      <Route
        path="/complements/items/:id/edit/:item"
        exact
        component={ComplementItemForm}
        isPrivate
      />

      <Route path="/banners" exact component={BannersForm} isPrivate />

      <Route path="/deliverymen" exact component={Deliverymen} isPrivate />
      <Route path="/deliverymen/create" component={DeliverymenForm} isPrivate />
      <Route
        path="/deliverymen/edit/:id"
        component={DeliverymenForm}
        isPrivate
      />

      <Route path="/coupons" exact component={Coupons} isPrivate />
      <Route path="/coupons/create" component={CouponForm} isPrivate />
      <Route path="/coupons/edit/:id" component={CouponForm} isPrivate />

      {REACT_APP_CHATBOT_WPP && (
        <Route path="/promoter" exact component={Promoter} isPrivate />
      )}

      <Route path="/clients" exact component={Clients} isPrivate />
      <Route path="/clients/create" component={ClientForm} isPrivate />
      <Route path="/clients/edit/:id" component={ClientForm} isPrivate />

      <Route path="/clients/orders/:id" component={OrdersClient} isPrivate />

      <Route path="/cashflow/create" component={CashFlowForm} isPrivate />
      <Route path="/cashflow/edit/:id" component={CashFlowForm} isPrivate />

      <Route path="/buyoncredit/:id" component={ClientsBuyOnCredit} isPrivate />
      <Route path="/buyoncredit" component={OrdersOnCredit} isPrivate />

      <Route
        path="/clients/addresses/:id"
        exact
        component={ClientAddresses}
        isPrivate
      />
      <Route
        path="/clients/addresses/:id/create"
        component={ClientAddressForm}
        isPrivate
      />
      <Route
        path="/clients/addresses/:id/edit/:item"
        component={ClientAddressForm}
        isPrivate
      />

      <Route path="/menus" exact component={Menus} isPrivate />
      <Route path="/menus/create" component={MenuForm} isPrivate />
      <Route path="/menus/edit/:id" component={MenuForm} isPrivate />

      <Route path="/supplies" exact component={Supplies} isPrivate />
      <Route path="/supplies/create" component={SupplieForm} isPrivate />
      <Route path="/supplies/edit/:id" component={SupplieForm} isPrivate />

      <Route path="/settings" component={Settings} isPrivate />
      <Route path="/distances" component={DistancesForm} isPrivate />
      <Route path="/tables" component={TablesForm} isPrivate />
      <Route path="/print-qrcode" component={PrintQrCode} isPrivate />
      <Route path="/resume" component={Resume} isPrivate />

      <Route path="/orders" exact component={Orders} isPrivate />
      {/* <Route path="/orders/create" component={OrderForm} isPrivate />
      <Route path="/orders/edit/:id" component={OrderForm} isPrivate /> */}
      <Route path="/orders/details/:id" component={OrderDetails} isPrivate />

      <Route path="/table-orders" exact component={OrdersTable} isPrivate />
      <Route path="/table-orders/:id" component={OrderTableDetails} isPrivate />

      {/* APP */}
      <Route path="/:id" exact component={AppHome} isPrivate />
      <Route path="/:id/about" component={AppAbout} isPrivate />
      <Route path="/:id/cart" component={AppCart} isPrivate />
      <Route path="/:id/checkout" component={AppCheckout} isPrivate />
      <Route path="/:id/orders" component={AppOrders} isPrivate />
      <Route
        path="/:id/category/:category"
        component={AppHomeCategory}
        isPrivate
      />

      <Route path="*" component={Orders} />
    </Switch>
  );
};

export default CompanyRoutes;
